import Vue from 'vue'
import Router from 'vue-router'
import VaelgHotel from '@/views/1-VaelgHotel.vue'
import VaerelseEllerParkering from '@/views/2-VaerelseEllerParkering.vue'
import startDato from '@/views/3-startDato.vue'
import slutDato from '@/views/4-slutDato.vue'
import vaelgType from '@/views/5-vaelgType.vue'
import vilDuVaelge from '@/views/5.1-vilDuVaelge.vue'
import vaelgVaerelse from '@/views/5.2-vaelgVaerelse.vue'
import ekstra from '@/views/6-ekstra.vue'
import oplysninger from '@/views/8-oplysninger.vue'
import opsummering from '@/views/9-opsummering.vue'
import betaling from '@/views/10-betaling.vue'
import betalingEAN from '@/views/10.1-betalingEAN.vue'
import faktura from '@/views/11-faktura.vue'
import cancel from '@/views/cancel.vue'
import administration from '@/views/administration/administration.vue'
import afbestil from '@/views/administration/afbestil.vue'
import efterbestilling from '@/views/administration/efterbestilling.vue'
import efterbestilling2 from '@/views/administration/efterbestilling-2.vue'
import efterbestilling3 from '@/views/administration/efterbestilling-3.vue'
import efterbestillingFaktura from '@/views/administration/faktura.vue'
import efterbestillingCancel from '@/views/administration/cancel.vue'
import i18n from '@/plugins/i18n';
//import { push } from 'core-js/fn/array'

Vue.use(Router)

window.popStateDetected = false
window.addEventListener('popstate', () => {
  window.popStateDetected = true
})

export default new Router({
  routes: [
    /* Hvis der ikke er angivet en underside, så vis startsiden på dansk */
    {
      path: '/',
      redirect: '/da'
    },
    /* Catch-all hvis der angives en ikke-eksisterende side, så vis startsiden på dansk */
    {
      path: '*',
      redirect: '/en'
    },
    {
    path: '/:lang',
    component: {
      template: '<router-view></router-view>'
    },
    beforeEnter (to, from, next) {
      const lang = to.params.lang
      //console.log('lang: ');
      //console.log(lang);
      if (!['en','de','da'].includes(lang)) return next('en')
      if (i18n.locale !== lang) {
        i18n.locale = lang
      }
      return next()
    },
    children: [
      {
        path: ':koncern',
        name: '/1-VaelgHotel',
        component: VaelgHotel
      },
      {
        path: ':koncern/hotel/:postnr',
        name: '2-VaerelseEllerParkering',
        component: VaerelseEllerParkering
      },
      {
        path: ':koncern/hotel/:postnr/startdato',
        name: '3-startDato',
        component: startDato
      },
      {
        path: ':koncern/hotel/:postnr/slutdato',
        name: '4-slutDato',
        component: slutDato
      },
      {
        // Der er en specielt route til denne side, da den er landingpage for Google Hotel Ads, og derfor skal kunne linkes til direkte
        path: ':koncern/vaerelsestype/:roomtype/hotel/:hotel/checkin/:checkin/checkout/:checkout/:occupancy?',
        name: '5-vaelgType',
        component: vaelgType
      },
      {
        path: ':koncern/vilduvaelge',
        name: '5.1-vilDuVaelge',
        component: vilDuVaelge
      },
      {
        path: ':koncern/vaelgVaerelse',
        name: '5.2-vaelgVaerelse',
        component: vaelgVaerelse
      },
      {
        path: ':koncern/ekstra',
        name: '6-ekstra',
        component: ekstra
      },
      {
        path: ':koncern/oplysninger',
        name: '8-oplysninger',
        component: oplysninger
      },
      {
        path: ':koncern/opsummering',
        name: '9-opsummering',
        component: opsummering
      },
      {
        path: ':koncern/betaling',
        name: '10-betaling',
        component: betaling
      },
      {
        path: ':koncern/betalingEAN',
        name: '10.1-betalingEAN',
        component: betalingEAN
      },
/*       {
        path: 'faktura/:refno/:complete',
        name: '11-faktura',
        component: faktura
      }, */
      {
        path: ':koncern/faktura/:refno/:complete/:paymentType/:URLparams?',
        name: '11-faktura',
        component: faktura
      },
      {
        path: ':koncern/cancel',
        name: 'cancel',
        component: cancel
      },
      {
        path: ':koncern/administration',
        name: 'administration',
        component: administration
      },
      {
        path: ':koncern/administration/afbestil',
        name: 'afbestil',
        component: afbestil
      },
      {
        path: ':koncern/administration/efterbestilling',
        name: 'efterbestilling',
        component: efterbestilling
      },
      {
        path: ':koncern/administration/efterbestilling/2',
        name: 'efterbestilling2',
        component: efterbestilling2
      },
      {
        path: ':koncern/administration/efterbestilling/3',
        name: 'efterbestilling3',
        component: efterbestilling3
      },      
      {
        path: ':koncern/administration/efterbestilling/faktura/:refno/:complete/:paymentType/:URLparams?',
        name: 'efterbestillingFaktura',
        component: efterbestillingFaktura
      },
      {
        path: ':koncern/administration/efterbestilling/cancel',
        name: 'efterbestillingCancel',
        component: efterbestillingCancel
      },
      {
        path: '/about',
        name: 'about',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
      }
    ],
  }],
  mode: 'history',
})
